import BackgroundCardGroup from './background-card-group/background-card-group.vue'
import Calculator from './calculator/calculator.vue'
import Carousel from './carousel/carousel.vue'
import DassaultLink from './dassault-link/dassault-link.vue'
import Hero from './hero/hero.vue'
import NbBannerMedia from './nb-banner-media/nb-banner-media.vue'
import NtMostRecent from './nt-most-recent/nt-most-recent.vue'
import NtTabItem from './nt-tabs/nt-tab-item.vue'
import NtTabs from './nt-tabs/nt-tabs.vue'
import NtThemeArticles from './nt-theme-articles/nt-theme-articles.vue'
import NtVideosCarousel from './nt-videos-carousel/nt-videos-carousel.vue'
import SmartBanner from './smart-banner/smart-banner.vue'
import SmartBannerPrimary from './smart-banner/smart-banner--primary.vue'
import SmartBannerSecondary from './smart-banner/smart-banner--secondary.vue'
import SmartBannerTertiary from './smart-banner/smart-banner--tertiary.vue'
import SmartBannerQuaternary from './smart-banner/smart-banner--quaternary.vue'
import SmartBannerQuinary from './smart-banner/smart-banner--quinary.vue'
import SmartBannerSenary from './smart-banner/smart-banner--senary.vue'
import SmartBannerSeptenary from './smart-banner/smart-banner--septenary.vue'
import SmartBannerOctonary from './smart-banner/smart-banner--octonary.vue'
import SocialFeedWrapper from './social-feed-wrapper/social-feed-wrapper.vue'
import SocialPostsCarousel from './social-posts-carousel/social-posts-carousel.vue'
import SocialPostsGrid from './social-posts-grid/social-posts-grid.vue'
import DynamicTable from './dynamic-table/dynamic-table.vue'
import Timeline from './timeline/timeline.vue'

export default [
  BackgroundCardGroup,
  Calculator,
  Carousel,
  DassaultLink,
  Hero,
  NbBannerMedia,
  NtMostRecent,
  NtTabItem,
  NtTabs,
  NtThemeArticles,
  NtVideosCarousel,
  SmartBanner,
  SmartBannerPrimary,
  SmartBannerSecondary,
  SmartBannerTertiary,
  SmartBannerQuaternary,
  SmartBannerQuinary,
  SmartBannerSenary,
  SmartBannerSeptenary,
  SmartBannerOctonary,
  SocialFeedWrapper,
  SocialPostsCarousel,
  SocialPostsGrid,
  DynamicTable,
  Timeline
]
